<template>
  <el-row class="link">
    <el-col :span="2" style="display:flex">
        <el-tooltip effect="dark" :content="linkCopied?'Copied to clipboard':'Copy'" placement="top">
            <div class="copy-icon" v-clipboard:copy="link" v-clipboard:success="onCopy" v-clipboard:error="resetCopyStatus" @mouseenter="resetCopyStatus">
                <IconBase
                    :height="24"
                    :width="24"
                    :view-box="`0 0 24 24`"
                    :fill="'#E7E6FA'"
                >
                    <IconCopy />
                </IconBase>
            </div>
        </el-tooltip>
    </el-col>
    <el-col :span="20" style="align-self: flex-end; padding: 3px 20px">
        <a :href="externalLink" class="shared-link" @click.prevent="openLink(link)">{{ link }}</a>
    </el-col>
    <el-col :span="2">
        <el-tooltip effect="dark" :content="'Remove'" placement="top">
            <div class="bin-icon" @click="handleDelete">
                <IconBase
                    :height="24"
                    :width="24"
                    :view-box="`0 0 24 24`"
                    :fill="'#E7E6FA'"
                >
                    <IconBin />
                </IconBase>
            </div>
        </el-tooltip>
    </el-col>
  </el-row>
</template>

<script>
import IconBase from '../IconBase'
import IconCopy from '../icons/IconCopy'
import IconBinOutline from '../icons/IconBinOutline'

export default {
    components: {
        IconBase,
        IconCopy,
        IconBin: IconBinOutline,
    },
    props: {
        link: {
            type: String,
            default: null
        },
        index: {
            type: Number,
            default: null
        }
    },
    data(){
        return {
            linkCopied: false,
            externalLink: this.link
        }
    },
    mounted(){
        this.updateExternalLink();
    },
    methods: {
        updateExternalLink(){
            try {
                new URL(this.link);
            } catch (error) {
                try {
                    const updatedUrl = `https://${this.link}`;
                    new URL(updatedUrl);
                    this.externalLink = updatedUrl;
                } catch (error) {
                    console.error("An error occurred:", error);
                }
            }
        },
        handleDelete(){
            this.$emit('link-deleted', this.index)
        },
        onCopy(){
            this.linkCopied = true
        },
        resetCopyStatus(){
            this.linkCopied = false
        },
        openLink(){
            const width = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;

            const height = window.innerHeight
                || document.documentElement.clientHeight
                || document.body.clientHeight;

            const popupWidth = width * 0.6
            const popupHeight = height * 0.6
            const offsetLeft = ( width - popupWidth ) * 0.5
            const offsetTop = ( height - popupHeight) * 0.5
            window.open(this.externalLink, '_blank', `location=yes,height=${popupHeight},width=${popupWidth},scrollbars=yes,status=yes,top=${offsetTop},left=${offsetLeft}`);
        }
    }

}
</script>

<style scoped>
.el-row.link {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
}
.copy-icon, .bin-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 36px;
    background: #3E3E52;
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 3px 3px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    margin-left: 3px;
    cursor: pointer;
}
.bin-icon i {
    color: #d44343;
    font-size: 20px;
}
.el-input.edit-link__input {
    width: 350px;
    height: 36px;
}
>>>.el-input__inner {
    height: 36px;
    line-height: 36px;
}
button.el-button.el-button--default,
button.el-button.el-button--default:hover {
    padding: 0;
    border: none;
    position: relative;
    left: -35px;
    width: 69px;
    height: 36px;
    background: #52B7CC;
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 3px 3px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
}

.shared-link {
    display: inline-block;
    color: #52B7CC;
    text-decoration: underline;
    font-size: 14px;
    font-weight: 18px;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
